import styled from 'styled-components';
import colors from '../../../config/colors';

const AdsPanelMain = styled.div`

  h4 {
    font-size: 20px;
    margin: 0;
  }

  p {
    font-family: "Gilroy-Medium";
    color: ${colors.GRAY_TEXT_MEDLIGHT};
    margin: 0;

    span {

      &:before {
        content: "";
        width: 3px;
        height: 3px;
        display: inline-block;
        margin: 4px 8px;
        background: ${colors.GRAY_TEXT_MEDLIGHT};
        border-radius: 50%;
      }

      &:first-of-type {
        &:before {
          display: none;
        }
      }
    }
  }
`;

const AdsPanelInfo = styled.div`

  p {
    font-family: "Gilroy-Medium";
    font-size: 14px;
    color: ${colors.GRAY_TEXT_MEDLIGHT};
    line-height: 24px;
    margin: 0 0 3px;

    svg {
      margin-right: 6px;
      width: 14px;
      height: 14px;
      stroke: ${colors.GRAY_TEXT_MEDLIGHT};
    }

    span {

      &:before {
        content: "";
        width: 3px;
        height: 3px;
        display: inline-block;
        margin: 4px 8px;
        background: ${colors.GRAY_TEXT_MEDLIGHT};
        border-radius: 50%;
      }

      &:first-of-type {
        &:before {
          display: none;
        }
      }
    }
  }
`;

const ListStatus = styled.ul`
  padding: 0;
  margin: 14px 0 0;
  list-style: none;
  text-align: right;
`;

const PanelTitleSavedJobs = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const SavedJobsImage = styled.div`
  width: 91px;
  height: 89px;
  border-radius: 10px;
  flex-shrink: 0;
  box-shadow: 0 0 20px rgba(93,93,93,0.16);
  margin-right: 22px;

  @media (max-width: 767px) {
    margin: 0 0 10px;
  }

  img {
    width: 91px;
    height: 89px;
    object-fit: contain;
    padding: 3px;
  }
`;

const AddOptions = styled.a`
  background: ${colors.WHITE_COLOR};
  position: absolute;
  z-index: 1;
  top: 0;
  height: 48px;
  right: 0;
  opacity: 0;
  pointer-events: none;
  padding: 12px 16px;
  border: 2px solid ${colors.GRAY_EXTRA_LIGHT};
  transition: all 150ms ease-in-out;
  display: flex;
  cursor: pointer;
  align-items: center;
  font-size: 12px;
  color: ${colors.TEXT_BLACK};
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: ${colors.RED_COLOR};

    svg {
      stroke: ${colors.RED_COLOR};
    }
  }

  svg {
    width: 16px;
    height: 18px;
    margin-right: 4px;
    transition: all 150ms ease-in-out;
    stroke: ${colors.TEXT_BLACK};
  }
`;

const AdsPanel = styled.div`
  display: flex;
  align-items: center;
  background: ${colors.GRAY_EXTRA_LIGHT};
  padding: 16px 32px;
  margin: 0 0 10px;
  position: relative;
  transition: background 150ms ease-in-out;

  @media (min-width: 992px) {

    @supports not (-webkit-overflow-scrolling: touch) {

      &:hover {
        background: rgba(245,191,81,0.1);

        ${AddOptions} {
          opacity: 1;
          pointer-events: auto;
          display: flex;
        }
      }
    }
  }

  @supports (-webkit-overflow-scrolling: touch) {
    &:active {
      background: ${colors.BACKGROUND_GRAY};

      ${AddOptions} {
        opacity: 1;
        pointer-events: auto;
        display: flex;
      }
    }
  }

  @supports not (-webkit-overflow-scrolling: touch) {
    &:hover {
      background: rgba(245,191,81,0.1);

      ${AddOptions} {
        opacity: 1;
        pointer-events: auto;
        display: flex;
      }
    }
  }
`;

export {
  AdsPanel,
  AdsPanelMain,
  AdsPanelInfo,
  ListStatus,
  PanelTitleSavedJobs,
  SavedJobsImage,
  AddOptions
};
